<script setup lang="ts">
import { type AdminProviderType, EProviders } from '@rfc/rfc-components-library/types'
import { provide } from 'vue'
import DeviceActions from '../DeviceComponents/DeviceActions.vue'
import DeviceInformations from '../DeviceComponents/DeviceInformations.vue'

provide<AdminProviderType>(EProviders.ADMIN, {
    DeviceInformationsTabActions: DeviceActions,
    DeviceInformationsTabSections: DeviceInformations
})
</script>

<template>
    <slot />
</template>
